class Wishlist {
  constructor() {
    this.isWishlistPage = false
    this.storageKey = 'm-wishlist-products'
    this.products = []
    this.productNodes = {}

    this.pageTemplate = 'page.wishlist'
    this.addedClass = 'added-to-wishlist'
    this.hasItemClass = 'wishlist-has-item'
    this.selectors = {
      container: '.m-wishlist-page-content__wrapper',
      noProducts: '.m-wishlist-no-products',
      wrapper: '.m-wishlist-card',
      productCard: '.m-product-card',
      wishlistButton: '.m-wishlist-button',
      wishlistText: '.m-wishlist-button-text',
      removeButton: '.m-wishlist-remove-button',
      count: '.m-wishlist-count'
    }

    try {
      this.products = Array.from(new Set(Array.from(JSON.parse(localStorage.getItem(this.storageKey)) || [])))
    } catch (e) {
      this.products = []
    }

    const pathname = window.location.pathname.replace(/\/+$/, '')
    const isWishlistPath = pathname === '/pages/wishlist' || pathname.endsWith('/pages/wishlist')
    this.isWishlistPage = MinimogSettings.template === this.pageTemplate || isWishlistPath

    this.init()
  }

  init = async () => {
    if (this.isWishlistPage) {
      await this.renderWishlistPage()
      this.addEventToRemoveButtons()
    }
    this.setWishlistButtonsState()
    this.addEventToWishlistButtons()
    this.updateWishlistCount()
  }

  saveToStorage = () => {
    this.products = Array.from(new Set(this.products))
    localStorage.setItem(this.storageKey, JSON.stringify(this.products))
  }

  addToWishlist(handle) {
    if (handle && this.products.indexOf(handle) === -1) {
      this.products.push(handle)
      this.saveToStorage()
    }
  }

  removeFromWishlist(handle) {
    this.products = this.products.filter(hdl => hdl !== handle)
    this.saveToStorage()
  }

  normalizeHandle(value) {
    let handle = String(value || '').trim()
    if (!handle) return ''
    try {
      if (/^https?:\/\//i.test(handle)) handle = new URL(handle).pathname
    } catch (e) {}
    if (handle.indexOf('/products/') > -1) handle = handle.split('/products/').pop()
    handle = handle.split('?')[0].split('#')[0].replace(/^\/+|\/+$/g, '')
    try { handle = decodeURIComponent(handle) } catch (e) {}
    return handle
  }

  escapeHTML(value) {
    const div = document.createElement('div')
    div.textContent = value == null ? '' : String(value)
    return div.innerHTML
  }

  formatPrice(cents) {
    const amount = Number(cents || 0) / 100
    return `Rs. ${amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
  }

  rootUrl() {
    const root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/'
    return root.endsWith('/') ? root : `${root}/`
  }

  async loadThemeProductCard(handle) {
    const response = await fetch(`${this.rootUrl()}products/${encodeURIComponent(handle)}?view=grid-card-item`, { credentials: 'same-origin' })
    if (!response.ok) return null
    const html = await response.text()
    if (!html || html.indexOf('m-product-card') === -1) return null

    const item = document.createElement('DIV')
    item.classList.add('m:column', 'm-wishlist-card')
    item.innerHTML = html
    return item.querySelector(this.selectors.productCard) ? item : null
  }

  async loadProductJSONCard(handle) {
    const response = await fetch(`${this.rootUrl()}products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin' })
    if (!response.ok) return null
    const product = await response.json()
    if (!product || !product.title) return null

    const item = document.createElement('DIV')
    item.classList.add('m:column', 'm-wishlist-card', 'wn-wishlist-fallback')

    let image = product.featured_image || (product.images && product.images[0]) || ''
    if (image && typeof image === 'object') image = image.src || ''
    if (image && image.indexOf('//') === 0) image = `https:${image}`

    const productUrl = `${this.rootUrl()}products/${handle}`
    const price = Number(product.price || 0)
    const compare = Number(product.compare_at_price || 0)

    item.innerHTML = `
      <article class="wn-wishlist-fallback-card">
        <a class="wn-wishlist-fallback-card__image" href="${this.escapeHTML(productUrl)}">
          ${image ? `<img src="${this.escapeHTML(image)}" alt="${this.escapeHTML(product.title)}" loading="lazy">` : ''}
        </a>
        <div class="wn-wishlist-fallback-card__info">
          <a class="wn-wishlist-fallback-card__title" href="${this.escapeHTML(productUrl)}">${this.escapeHTML(product.title)}</a>
          <div class="wn-wishlist-fallback-card__price">
            <strong>${this.formatPrice(price)}</strong>
            ${compare > price ? `<del>${this.formatPrice(compare)}</del>` : ''}
          </div>
        </div>
      </article>`

    return item
  }

  setWishlistButtonsState = () => {
    const buttons = document.querySelectorAll(this.selectors.wishlistButton)
    buttons.forEach(btn => {
      const prodHandle = btn && btn.dataset.productHandle
      if (this.products.indexOf(prodHandle) >= 0 && btn && !btn.classList.contains(this.addedClass)) {
        this.toggleButtonState(btn, true)
        if (this.isWishlistPage) {
          btn.classList.remove(this.selectors.wishlistButton.replace('.', ''))
          btn.classList.add(this.selectors.removeButton.replace('.', ''))
        }
      }
    })
  }

  updateWishlistCount = () => {
    const size = this.products.length
    document.querySelectorAll(this.selectors.count).forEach(elem => {
      elem.textContent = size
      if (size < 1) elem.classList.add('m:hidden')
      else elem.classList.remove('m:hidden')
    })
    document.body.classList[size ? 'add' : 'remove'](this.hasItemClass)
  }

  addEventToWishlistButtons = () => {
    addEventDelegate({
      selector: this.selectors.wishlistButton,
      handler: (e, btn) => {
        e.preventDefault()
        const productHandle = btn && btn.dataset.productHandle
        if (productHandle) {
          const active = !btn.classList.contains(this.addedClass)
          this.toggleButtonState(btn, active)
          this.updateWishlistCount()

          document.querySelectorAll(this.selectors.wishlistButton).forEach(btnItem => {
            if (btnItem && btnItem.dataset.productHandle === productHandle && btnItem !== btn) {
              const isAdded = !btnItem.classList.contains(this.addedClass)
              this.toggleButtonState(btnItem, isAdded)
            }
          })
        }
      }
    })
  }

  toggleButtonState = (btn, active) => {
    const productHandle = btn && btn.dataset.productHandle
    const wishlistText = btn && btn.querySelector(this.selectors.wishlistText)

    if (active) {
      this.addToWishlist(productHandle)
      btn.classList.add(this.addedClass)
    } else {
      this.removeFromWishlist(productHandle)
      btn.classList.remove(this.addedClass)
    }

    if (wishlistText) {
      const temp = wishlistText.dataset.revertText
      wishlistText.dataset.revertText = wishlistText.textContent
      wishlistText.textContent = temp
    }
  }

  addEventToRemoveButtons = () => {
    addEventDelegate({
      selector: this.selectors.removeButton,
      handler: (e, btn) => {
        e.preventDefault()
        const prod = btn && btn.closest(this.selectors.wrapper)
        if (prod) prod.remove()

        const productHandle = btn && btn.dataset.productHandle
        if (productHandle) {
          this.removeFromWishlist(productHandle)
          this.updateWishlistCount()
          if (!this.products.length) this.showNoProductsMessage()
        }
      }
    })
  }

  wishlistRemoveButton(prdHandle) {
    const html = `<svg class="m-svg-icon--medium" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>`
    const button = document.createElement('DIV')
    button.classList.add('m-tooltip', 'm-wishlist-remove-button', 'm:block', 'md:m:hidden')
    button.setAttribute('data-product-handle', prdHandle)
    button.innerHTML = html
    return button
  }

  renderWishlistPage = async () => {
    const container = document.querySelector(this.selectors.container)
    const noProducts = document.querySelector(this.selectors.noProducts)
    if (!container) return

    container.classList.remove('m:hidden')
    container.innerHTML = ''
    if (noProducts) noProducts.classList.add('m:hidden')
    this.productNodes = {}

    if (this.products.length) {
      await Promise.all(this.products.map(async storageValue => {
        const handle = this.normalizeHandle(storageValue)
        if (!handle) return

        let item = null
        try { item = await this.loadThemeProductCard(handle) } catch (e) {}
        if (!item) {
          try { item = await this.loadProductJSONCard(handle) } catch (e) {}
        }

        if (item) {
          item.appendChild(this.wishlistRemoveButton(storageValue))
          this.productNodes[storageValue] = item
        }
      }))
    }

    let rendered = 0
    this.products.forEach(storageValue => {
      const prod = this.productNodes[storageValue]
      if (prod) {
        container.appendChild(prod)
        prod.classList.remove('m:hidden')
        rendered += 1
      }
    })

    if (!rendered) this.showNoProductsMessage()
    else this.setWishlistButtonsState()

    container.classList.add('is-visible')
  }

  showNoProductsMessage = () => {
    const container = document.querySelector(this.selectors.container)
    const noProducts = document.querySelector(this.selectors.noProducts)
    if (container) container.classList.add('m:hidden')
    if (noProducts) noProducts.classList.remove('m:hidden')
  }
}

MinimogTheme.Wishlist = new Wishlist()
